import { render, staticRenderFns } from "./YwArtificialPatrolPlanModal.vue?vue&type=template&id=2a2a7c7c&scoped=true&"
import script from "./YwArtificialPatrolPlanModal.vue?vue&type=script&lang=js&"
export * from "./YwArtificialPatrolPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a7c7c",
  null
  
)

export default component.exports